import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f5f7fa',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '900px',
        margin: '0 auto',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        lineHeight: '1.6',
        color: '#333'
      }}>
        <h1 style={{ fontSize: '32px', marginBottom: '10px', color: '#2c3e50' }}>
          Privacy Policy
        </h1>
        <p style={{ color: '#7f8c8d', marginBottom: '30px' }}>
          <strong>DiNiTracker Payment Integration</strong><br />
          Last Updated: January 6, 2026
        </p>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Introduction</h2>
          <p>
            DiNiTracker Payment Integration ("we", "our", "us") is operated by DiNi Wigs LLC.
            This privacy policy explains how we handle payment information when using our Clover integration.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Information We Collect</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>Customer names and contact information</li>
            <li>Payment card information (tokenized only - no raw card data stored)</li>
            <li>Transaction history</li>
            <li>Order details</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>How We Use Information</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>Process customer payments</li>
            <li>Save payment methods for future transactions</li>
            <li>Generate transaction receipts</li>
            <li>Comply with financial regulations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Data Security</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>All payment card data is tokenized via Clover's PCI-compliant system</li>
            <li>We never store raw credit card numbers</li>
            <li>All data transmission uses HTTPS/TLS encryption</li>
            <li>Customer data is encrypted at rest</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Third-Party Services</h2>
          <p>
            We use Clover (Fiserv) for payment processing. Clover's privacy policy can be found at:{' '}
            <a href="https://www.clover.com/privacy-policy" target="_blank" rel="noopener noreferrer"
               style={{ color: '#3498db', textDecoration: 'none' }}>
              https://www.clover.com/privacy-policy
            </a>
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Data Retention</h2>
          <ul style={{ marginLeft: '20px' }}>
            <li>Payment tokens: Retained until customer requests deletion</li>
            <li>Transaction records: Retained for 7 years per financial regulations</li>
          </ul>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Your Rights</h2>
          <p>Customers can request:</p>
          <ul style={{ marginLeft: '20px' }}>
            <li>Access to their saved payment information</li>
            <li>Deletion of saved payment methods</li>
            <li>Copy of transaction history</li>
          </ul>
          <p style={{ marginTop: '15px' }}>
            Contact us at:{' '}
            <a href="mailto:it@diniwigs.com" style={{ color: '#3498db', textDecoration: 'none' }}>
              it@diniwigs.com
            </a>
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Changes to Privacy Policy</h2>
          <p>
            We will notify customers of any material changes to this policy via email or through our platform.
          </p>
        </section>

        <section style={{ marginBottom: '30px' }}>
          <h2 style={{ fontSize: '24px', marginBottom: '15px', color: '#34495e' }}>Contact</h2>
          <p>
            <strong>DiNi Wigs LLC</strong><br />
            Email:{' '}
            <a href="mailto:it@diniwigs.com" style={{ color: '#3498db', textDecoration: 'none' }}>
              it@diniwigs.com
            </a><br />
            Phone: (201) 844-3508
          </p>
        </section>

        <div style={{
          marginTop: '50px',
          paddingTop: '20px',
          borderTop: '1px solid #ecf0f1',
          textAlign: 'center',
          color: '#95a5a6',
          fontSize: '14px'
        }}>
          <p>© 2026 DiNi Wigs LLC. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
